import * as actions from "./actions";
import * as getters from "./getters";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    pageFacture: {
      form: {
        nums: [],
      },
      page: 1,
      tab: "tab-1",
      onglets: {
        contrat: false,
        marche: false,
        commande: false,
        facture: false,
        tier: false,
      },
      panel: [0, 2],
      page_tab: 1,
      page_count: 10,
      page_scroll: 0,
      page_showElem: "",
    },
    pageBordereau: {
      form: {},
      page: 1,
      tab: "tab-1",
      onglets: {
        bordereau: true,
        facture: false,
      },
      panel: [0, 1, 2],
      page_tab: 1,
      page_count: 10,
      page_scroll: 0,
      page_showElem: "",
    },
    pageContrat: {
      form: {},
      page: 1,
      tab: "tab-1",
      onglets: {
        contrat: true,
        tier: false,
      },
      panel: [0, 1],
      page_tab: 1,
      page_count: 10,
      page_scroll: 0,
      page_showElem: "",
    },
    pageTier: {
      form: {},
      page: 1,
      tab: "tab-1",
      onglets: {
        tier: true,
      },
      panel: [0, 1],
      page_tab: 1,
      page_count: 10,
      page_scroll: 0,
      page_showElem: "",
    },
    pageMarche: {
      form: {},
      page: 1,
      tab: "tab-1",
      onglets: {
        marche: true,
        tier: false,
      },
      panel: [0, 1],
      page_tab: 1,
      page_count: 10,
      page_scroll: 0,
      page_showElem: "",
    },
    pageOd: {
      form: {},
      page: 1,
      tab: "tab-1",
      onglets: {
        od: true,
      },
      panel: [0, 1],
      page_tab: 1,
      page_count: 10,
      page_scroll: 0,
      page_showElem: "",
    },
    pageCommande: {
      form: {
        nums: [],
      },
      page: 1,
      tab: "tab-1",
      onglets: {
        commande: true,
        contrat: false,
        marche: false,
        tier: false,
      },
      panel: [0, 1],
      page_tab: 1,
      page_count: 10,
      page_scroll: 0,
      page_showElem: "",
    },
    pageMission: {
      form: {
        nums: [],
      },
      page: 1,
      tab: "tab-1",
      onglets: {
        mission: true,
        contrat: false,
        commande: false,
        tier: false,
      },
      panel: [0, 1, 2, 3],
      page_tab: 1,
      page_count: 10,
      page_scroll: 0,
      page_showElem: "",
    },
    pageAutreDocumentComptable: {
      form: {
        nums: [],
      },
      page: 1,
      tab: "tab-1",
      onglets: {
        autreDocumentComptableListe: true,
      },
      panel: [0, 1],
      page_tab: 1,
      page_count: 10,
      page_scroll: 0,
      page_showElem: "",
    },
    title: {
      name: "",
    },
  },
  actions,
  getters,
  mutations,
};
